import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { VendorService } from "@/repositories/vendors.repository";
import { DollarSign, FileIcon, Tag } from "lucide-react";

interface ParentServicesSectionProps {
  services: VendorService[];
}

export default function ParentServicesSection({ services }: ParentServicesSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Tag className="w-5 h-5 text-blue-600" />
          Service Categories
        </CardTitle>
      </CardHeader>
      <CardContent>
        {services.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {services.map((service) => (
              <div
                key={service.id}
                className="group flex items-center gap-3 p-4 border rounded-lg hover:border-blue-200 hover:bg-blue-50/50 transition-all duration-200 cursor-pointer"
              >
                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition-colors">
                  <FileIcon className="w-5 h-5 text-blue-600" />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-semibold text-sm text-gray-900 group-hover:text-blue-900 transition-colors">
                    {service.name}
                  </h4>
                  {service.price ? (
                    <div className="flex items-center gap-1 text-xs text-gray-600 mt-1">
                      <DollarSign className="w-3 h-3" />
                      <span className="font-medium">${service.price.toFixed(2)}</span>
                    </div>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8">
            <FileIcon className="w-12 h-12 text-muted-foreground mx-auto mb-3" />
            <p className="text-muted-foreground text-sm">No parent services found</p>
            <p className="text-muted-foreground text-xs mt-1">This vendor doesn't have any parent service categories</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
